import { render } from "./VueHeader.vue?vue&type=template&id=525548e2"
import script from "./VueHeader.vue?vue&type=script&lang=js"
export * from "./VueHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bayes-intraday-pwa-rt/bayes-intraday-pwa-rt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__